/* Reveal-on-scroll for the sg-dc-* sections.
 *
 * Ported from the design handoff's DCLogic component. Two behaviours from the
 * original are deliberately kept, because both fix real bugs:
 *
 *   1. The observer also fires when boundingClientRect.top < 0, so an element
 *      scrolled past before the observer attached is not left invisible.
 *   2. A sweep on scroll/hashchange/resize catches anything an anchor jump
 *      skipped over, which IntersectionObserver alone misses.
 *
 * Elements start visible in CSS terms only once JS runs; if JS never runs the
 * stylesheet's prefers-reduced-motion branch and this guard both leave content
 * readable rather than permanently transparent.
 */
(function () {
  function init() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('[data-sg-reveal]')
    );
    if (!nodes.length) return;

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) {
        n.classList.add('is-in');
      });
      return;
    }

    nodes.forEach(function (n, i) {
      var delay = (i % 3) * 70;
      n.style.transitionDelay = delay + 'ms, ' + delay + 'ms';
    });

    var show = function (n) {
      n.classList.add('is-in');
      io.unobserve(n);
    };

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) show(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    nodes.forEach(function (n) {
      io.observe(n);
    });

    var sweep = function () {
      nodes.forEach(function (n) {
        if (n.classList.contains('is-in')) return;
        if (n.getBoundingClientRect().top < window.innerHeight * 0.92) show(n);
      });
    };
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('hashchange', sweep);
    window.addEventListener('resize', sweep, { passive: true });
    sweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
